import React from "react";
import logo from "assets/logo-portrait-white.svg";
import { Box } from "@mui/material";

const AuthHeader: React.FC = () => {
  return (
    <Box display="flex" justifyContent="center" my={4}>
      <img src={logo} alt="logo" style={{ width: "100px" }} />
    </Box>
  );
};

export default AuthHeader;
